import React from "react";

/**
 * KpiCard - card di KPI per la dashboard compliance.
 *
 * Props:
 *  - icon: classe Bootstrap Icons (es. "bi-people")
 *  - title: testo del KPI (es. "Lavoratori attivi")
 *  - value: valore numerico/stringa
 *  - subtitle?: descrizione opzionale sotto il valore
 *  - tone?: 'primary' | 'success' | 'warning' | 'danger' | 'secondary' (default primary)
 *  - onClick?: handler opzionale di click
 *
 * NB: usiamo style inline per i colori di sfondo "soft" perché il progetto
 * monta Bootstrap 5.2.3 (le classi bg-*-subtle esistono solo da 5.3).
 */
const TONE_PALETTE = {
    primary:   { bg: "#cfe2ff", fg: "#0d6efd" },
    success:   { bg: "#d1e7dd", fg: "#198754" },
    warning:   { bg: "#fff3cd", fg: "#b58105" },
    danger:    { bg: "#f8d7da", fg: "#dc3545" },
    secondary: { bg: "#e2e3e5", fg: "#6c757d" },
    info:      { bg: "#cff4fc", fg: "#055160" },
};

export default function KpiCard({
    icon = "bi-graph-up",
    title = "",
    value = 0,
    subtitle,
    tone = "primary",
    onClick,
}) {
    const isClickable = typeof onClick === "function";
    const palette = TONE_PALETTE[tone] || TONE_PALETTE.primary;
    return (
        <div
            className="card border-0 shadow-sm h-100"
            role={isClickable ? "button" : undefined}
            onClick={isClickable ? onClick : undefined}
            style={{ cursor: isClickable ? "pointer" : "default" }}
        >
            <div className="card-body d-flex align-items-center">
                <div
                    className="me-3 rounded-circle d-flex align-items-center justify-content-center"
                    style={{
                        width: 56,
                        height: 56,
                        flex: "0 0 56px",
                        backgroundColor: palette.bg,
                        color: palette.fg,
                    }}
                >
                    <i className={`bi ${icon} fs-3`} />
                </div>
                <div className="flex-grow-1" style={{ minWidth: 0 }}>
                    <div className="text-muted small text-truncate">{title}</div>
                    <div className="fs-3 fw-bold lh-1">{value}</div>
                    {subtitle && <div className="text-muted small mt-1">{subtitle}</div>}
                </div>
            </div>
        </div>
    );
}
